exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-image-wrapper[data-v-4b3ad4ca]{height:100%}.select-image-wrapper .select-image[data-v-4b3ad4ca]{background:#edf0f2;border:1px solid #c1c5c7;color:#90a0b1;text-align:center;text-transform:uppercase;font-size:14px;padding:25px 20px;cursor:pointer}.select-image-wrapper .select-image svg[data-v-4b3ad4ca]{width:45px;fill:#90a0b1}.select-image-wrapper a[data-v-4b3ad4ca]{text-align:center;display:block;margin-top:10px;text-decoration:underline;font-size:13px;color:#184573;text-transform:uppercase}.select-image-wrapper .image-preview[data-v-4b3ad4ca]{max-height:242px;overflow:hidden;width:100%;height:100%}.select-image-wrapper .image-preview img[data-v-4b3ad4ca]{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b3ad4ca","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/cms/CMSAddImage.vue
// module id = 62Gf
// module chunks = 0 1